import { Store } from '@ngrx/store';
import { ErrorTracking } from '@shared/tracking';
import { Observable } from 'rxjs/Observable';
import { switchMap, take } from 'rxjs/operators';
import { ApiHttp } from './api-http.service';
import { push, remove, set, update } from './http-actions';
import { RootModel } from './root.model';
import { Reference, StoreState } from './store.model';

export class ListObservable<K extends keyof RootModel> extends Observable<
  ReadonlyArray<RootModel[K]>
> {
  constructor(
    private ref$: Observable<Reference<K>>,
    private apiHttp: ApiHttp,
    private store: Store<StoreState>,
    private errorTracking: ErrorTracking,
    source: Observable<ReadonlyArray<RootModel[K]>>,
  ) {
    super();
    this.source = source;
  }

  push(object: RootModel[K]): Promise<boolean> {
    return this.ref$
      .pipe(
        take(1),
        switchMap(ref =>
          push(ref, object, this.store, this.apiHttp, this.errorTracking),
        ),
      )
      .toPromise();
  }

  set(id: number | string, object: RootModel[K]): Promise<boolean> {
    return this.ref$
      .pipe(
        take(1),
        switchMap(ref =>
          set(ref, id, object, this.store, this.apiHttp, this.errorTracking),
        ),
      )
      .toPromise();
  }

  update(id: number | string, object: Partial<RootModel[K]>): Promise<boolean> {
    return this.ref$
      .pipe(
        take(1),
        switchMap(ref =>
          update(ref, id, object, this.store, this.apiHttp, this.errorTracking),
        ),
      )
      .toPromise();
  }

  remove(id: number | string): Promise<boolean> {
    return this.ref$
      .pipe(
        take(1),
        switchMap(ref =>
          remove(ref, id, this.store, this.apiHttp, this.errorTracking),
        ),
      )
      .toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/core/list-observable.ts